// Mirrors the backend guard in apps/files/validators.py::MAX_FILE_SIZE (150 * 1024 * 1024).
// Keep these two values in sync.
export const MAX_FILE_SIZE_MB = 150;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

// Mirrors the backend guard in apps/email/actions/send_email_action_handler.py::MAX_EMAIL_ATTACHMENT_TOTAL_BYTES.
// Keep these two values in sync. Sum of all attachment sizes per email.
export const MAX_EMAIL_ATTACHMENT_TOTAL_MB = 25;
export const MAX_EMAIL_ATTACHMENT_TOTAL_BYTES =
  MAX_EMAIL_ATTACHMENT_TOTAL_MB * 1024 * 1024;
